
import React from "react";
import { Textarea } from "@/components/ui/textarea";

interface ProfileTextAreaProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
}

const ProfileTextArea: React.FC<ProfileTextAreaProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  required = false,
  disabled = false,
}) => {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-medium">
        {label} {required && "*"}
      </label>
      <Textarea
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        required={required}
        aria-required={required ? "true" : undefined}
        disabled={disabled}
      />
    </div>
  );
};

export default ProfileTextArea;
